var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',[_c('AppFileUpload',{staticClass:"file-input-field",attrs:{"hide-details":"","uploadFunc":_vm.uploadFunc,"label":"Upload image (20x20)","uploadedFile":_vm.uploadedFile,"accept":"image/png, image/jpg","placeholder":"Upload image (20x20)"},on:{"onFileUploaded":_vm.onFileUploaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }